import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
export const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const spinReverse = keyframes`
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
`;

export const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

export const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

export const ping = keyframes`
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  text-align: center;
`;

export const AnimationContainer = styled.div`
  position: relative;
  width: 16rem;
  height: 16rem;
  margin: 0 auto 2rem;
`;

export const OuterGear = styled.div<any>`
  position: absolute;
  inset: 0;
  animation: ${(props: any) => (props.loading ? spin : "none")} 3s linear
    infinite;
`;

export const InnerGear = styled.div<any>`
  position: absolute;
  inset: 2rem;
  animation: ${(props: any) => (props.loading ? spinReverse : "none")} 2s linear
    infinite;
`;

export const CenterIcon = styled.div<any>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s;
  transform: scale(${(props: any) => (props.loading ? 1.1 : 1)});
`;

export const PulsingIcon = styled.div`
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const BouncingIcon = styled.div`
  animation: ${bounce} 1s ease-in-out infinite;
`;

export const Particle = styled.div<any>`
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  background: #60a5fa;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  animation: ${ping} 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  animation-delay: ${(props: any) => props.delay}s;
  transform: rotate(${(props: any) => props.rotation}deg) translateY(-6.25rem);
`;

export const StatusText = styled.div`
  margin-bottom: 2rem;
`;

export const Title = styled.h2<any>`
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: ${(props: any) => props.color || "#fff"};
  animation: ${(props: any) => (props.animate ? pulse : "none")} 1.5s
    ease-in-out infinite;
`;

export const Subtitle = styled.p`
  color: ${(props: any) => props.color || "#fff"};
  opacity: 0.9;
`;
